import { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useDispatch } from 'react-redux';

import { fetchApplicationConfig } from '~/data/applicationConfig';
import { fetchEmployeeDetails } from '~/data/employeeProfile';
import { fetchEmployees } from '~/data/employees';
import { fetchEnums } from '~/data/enums';
import { fetchLanguages } from '~/data/languages';
import { fetchOrganizationUnits } from '~/data/orgunits';
import { useAuthentication } from '~/data/user/useAuthentication';
import { LibraryComponentProviders } from '~/library/components/LibraryComponentProviders';
import { Providers } from '~/Providers';
import { EmployeeActions } from '~/scenes/PeopleModule/components/EmployeeActions';
import { AppDispatch } from '~/store';

export type AccountManagementMenu_OnUpdateLegacy = {
  onUpdateLegacy?: (updateReferences: string[]) => void;
};

export type AccountManagementMenuProps =
  AccountManagementMenu_OnUpdateLegacy & {
    employeeId: number;
  };

export const AccountManagementMenu = (props: AccountManagementMenuProps) => {
  const { employeeId } = props;
  const { userDetails, isAuthenticated } = useAuthentication();
  const dispatch: AppDispatch = useDispatch();
  useEffect(() => {
    if (isAuthenticated && !!userDetails) {
      dispatch(
        fetchOrganizationUnits({
          myRoles: userDetails!.roles,
          myId: userDetails!.employeeId,
        }),
      );
      dispatch(fetchApplicationConfig());
      dispatch(fetchEmployees({ myRoles: userDetails!.roles }));
      dispatch(fetchEmployeeDetails(`${employeeId}`));
      dispatch(fetchEnums());
      dispatch(fetchLanguages());
    }
  }, [dispatch, isAuthenticated, userDetails, employeeId]);

  if (!isAuthenticated) {
    return null;
  }

  return (
    <LibraryComponentProviders>
      <EmployeeActions {...props} />
    </LibraryComponentProviders>
  );
};

export const renderAccountManagementMenu = (
  containerId: string,
  props: AccountManagementMenuProps,
) => {
  ReactDOM.render(
    <Providers>
      <AccountManagementMenu {...props} />
    </Providers>,
    document.getElementById(containerId),
  );
};
